import React, { useState } from 'react';
import { toast } from 'react-toastify';

const ControlModal = ({ light, onSave, onCancel }) => {
  const [controlData, setControlData] = useState({
    DeviceId: light.id || 0,
    Key: "D8dX0dnZCkFMpd9uqna3GbPBI8xFh4id",
    LightType: light.LightType || 0,
    ControlMode: light.control_mode === true ? 1 : 0,
    ScheduleId: light.ScheduleId || 1,
    GreenLightControl: light.GreenLightControl || 0,
    YellowLightControl: light.YellowLightControl || 0,
    RedLightControl: light.RedLightControl || 0,
    GreenDuration: light.GreenDuration || 20,
    YellowDuration: light.YellowDuration || 5,
    RedDuration: light.RedDuration || 25, 
    CycleTime: light.CycleTime || 60,
    selectedLight: light.PriorityDirectionControl === 1 ? '1' : light.PriorityDirectionControl === 2 ? '2' : null,
  });
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = () => {
    setIsSaving(true);
    onSave(controlData, (success) => {
      setIsSaving(false);
      if (success) {
          toast.success('Cập nhật thành công!', {
          position: 'top-center',
          autoClose: 5000,
        });
        onCancel(); // Đóng modal sau khi thành công
      } else {
        toast.error('Lỗi khi cập nhật. Vui lòng thử lại!', {
          position: 'top-center',
          autoClose: 5000,
        });
      }
    });
  };

  const handleCancel = () => {
    console.log('Closing ControlModal');
    onCancel();
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <div className="bg-blue-500 text-white p-2 rounded-t-lg">
          <h3 className="text-lg font-semibold mb-0">Điều khiển đèn giao thông</h3>
        </div>
        <div className="modal-body">
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-1">
              <label className="font-bold text-gray-800 text-sm mb-0">ID thiết bị</label>
              <input
                type="text"
                value={controlData.DeviceId}
                disabled
                className="border p-2 rounded w-full bg-gray-100"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold text-gray-800 text-sm mb-0">Chuỗi xác thực</label>
              <input
                type="text"
                value={controlData.Key}
                disabled
                className="border p-2 rounded w-full bg-gray-100"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold text-gray-800 text-sm mb-0">Chọn kết nối</label>
              <select
                value={controlData.LightType}
                onChange={(e) => setControlData({ ...controlData, LightType: parseInt(e.target.value) })}
                className="border p-2 rounded w-full"
              >
                <option value={0}>Tự động đồng bộ</option>
                <option value={1}>Cài qua RS485</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold text-gray-800 text-sm mb-0">Chế độ điều khiển</label>
              <select
                value={controlData.ControlMode}
                onChange={(e) => setControlData({ ...controlData, ControlMode: parseInt(e.target.value) })}
                className="border p-2 rounded w-full"
              >
                <option value={0}>Tự động</option>
                <option value={1}>Ưu tiên</option>
              </select>
            </div>
            <div className="flex flex-col gap-1 col-span-2 hidden">
              <label className="font-bold text-gray-800 text-sm mb-0">ID lịch điều khiển</label>
              <input
                type="number"
                value={controlData.ScheduleId}
                onChange={(e) => setControlData({ ...controlData, ScheduleId: parseInt(e.target.value) || 1 })}
                className="border p-2 rounded w-full"
                min="1"
              />
            </div>
            {controlData.ControlMode === 1 && (
              <fieldset className="border rounded-lg p-4 col-span-2">
                <legend className="text-base font-semibold">Chế độ ưu tiên</legend>
                <div className="grid grid-cols-3 gap-4">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="manualLightControl"
                      checked={controlData.selectedLight === '1'}
                      onChange={() =>
                        setControlData({ ...controlData, selectedLight: '1', PriorityDirectionControl: 1 })
                      }
                      className="mr-2"
                    />
                    Hướng A
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="manualLightControl"
                      checked={controlData.selectedLight === '2'}
                      onChange={() =>
                        setControlData({ ...controlData, selectedLight: '2', PriorityDirectionControl: 2 })
                      }
                      className="mr-2"
                    />
                    Hướng B
                  </label>
                </div>
              </fieldset>
            )}
            {controlData.ControlMode === 0 && (
              <fieldset className="border rounded-lg p-4 col-span-2">
                <legend className="text-base font-semibold">Cài đặt thời gian (chế độ tự động)</legend>
                <div className="grid grid-cols-3 gap-4">
                  <div className="flex flex-col gap-1">
                    <label className="font-bold text-gray-800 text-sm mb-0">Đèn xanh (tối đa 120s)</label>
                    <input
                      type="number"
                      value={controlData.GreenDuration}
                      onChange={(e) =>
                        setControlData({
                          ...controlData,
                          GreenDuration: Math.min(parseInt(e.target.value) || 1, 120),
                        })
                      }
                      className="border p-2 rounded w-full"
                      min="1"
                      max="120"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="font-bold text-gray-800 text-sm mb-0">Đèn vàng (tối đa 15s)</label>
                    <input
                      type="number"
                      value={controlData.YellowDuration}
                      onChange={(e) =>
                        setControlData({
                          ...controlData,
                          YellowDuration: Math.min(parseInt(e.target.value) || 1, 15),
                        })
                      }
                      className="border p-2 rounded w-full"
                      min="1"
                      max="15"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="font-bold text-gray-800 text-sm mb-0">Đèn đỏ (tối đa 135s)</label>
                    <input
                      type="number"
                      value={controlData.RedDuration}
                      onChange={(e) =>
                        setControlData({
                          ...controlData,
                          RedDuration: Math.min(parseInt(e.target.value) || 1, 135),
                        })
                      }
                      className="border p-2 rounded w-full"
                      min="1"
                      max="135"
                    />
                  </div>
                </div>
              </fieldset>
            )}
          </div>
          <div className="mt-4 flex justify-end space-x-2">
            <button
              onClick={handleSave}
              disabled={isSaving}
              className={`bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 ${
                isSaving ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isSaving ? 'Đang lưu' : 'Lưu'}
            </button>
            <button
              onClick={handleCancel}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Đóng cửa sổ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControlModal;